import React from 'react';
import PropTypes from 'prop-types';

export default function TerminologyIcon(props) {
  const { fill, width, height, className } = props;

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 15.264 16.688'
      className={className}
    >
      <g id='Grupo_12324' data-name='Grupo 12324' transform='translate(-328 -448)'>
        <path
          id='Caminho_11911'
          data-name='Caminho 11911'
          d='M1366.5,959.2v3.958h3.958Z'
          transform='translate(-1027.508 -510.887)'
          fill={fill}
        />
        <path
          id='Caminho_11912'
          data-name='Caminho 11912'
          d='M1350.53,978.13l-3.588-3.588-.342-.342v3.93h3.93Z'
          transform='translate(-1013.275 -521.615)'
          fill={fill}
        />
        <path
          id='Caminho_11913'
          data-name='Caminho 11913'
          d='M1335.788,978.425h-3.645V973.1H1327.9v12.416h9.568v-7.091h-1.68Z'
          transform='translate(-999.9 -520.828)'
          fill={fill}
        />
        <path
          id='Caminho_11914'
          data-name='Caminho 11914'
          d='M1352.071,963.425V958.1H1347.8v3.417l.4.4,3.958,3.958.627.626v4.044h4.613v-7.119Z'
          transform='translate(-1014.133 -510.1)'
          fill={fill}
        />
      </g>
    </svg>
  );
}

TerminologyIcon.defaultProps = {
  fill: '#cacaca',
  width: 15.264,
  height: 16.688
};

TerminologyIcon.propTypes = {
  fill: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  className: PropTypes.string
};
